import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { Controller } from 'react-hook-form';


const Otp=({ name, setValue, getValues, rules, errors,validationFn,label,control,clearErrors })=>{
    const [otp, setOtp] = useState('');

  const handleChange = (otpValue) => {
    // Ensure only numeric values are allowed
    if (/^\d*$/.test(otpValue)) {
      setValue(name, otpValue, { shouldValidate: false });
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").replace(/\D/g, ""); 
    if (pastedData) {
      setValue(name, pastedData.slice(0, 6), { shouldValidate: false }); 
    }
  };
    return (
    <div className="otp-input-box">
  <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <OtpInput
          value={getValues(name) || ""}
          onChange={(value) => {
            setValue(name, value, { shouldValidate: false });
            clearErrors(name); 
          }}
            numInputs={6}
            shouldAutoFocus
            onPaste={handlePaste}
            containerStyle="otp-container" 
         
            renderInput={(props,index) => (
              <input {...props} onKeyPress={(e) => {
                if (!/^\d$/.test(e.key)) {
                  e.preventDefault(); 
                }
              }} 
              className="otp-input" 
              style={{
                marginRight: index === 2 ? "2rem" : "0", 
                width: "2em", 
                height: "3em",
                fontSize: "1.5em",
                borderRadius: "23px",
                border: "1px solid #0E65FF",
                textAlign: "center",
                backgroundColor:'#E3F7FF',
              }}
              />
            )}
          />
        )}
        rules={{
          validate: (value) => {
            const { errorFlag, error } = validationFn({ FieldName: name, value });
            if (errorFlag) {
              return error;
            }
            return true;
          }
         }}
      />

       {errors?.[name] && <span className="p-error fs-6">{errors[name].message}</span>}
   </div>
    );

}

export default Otp;
